import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, LogIn, UserPlus } from 'lucide-react';

// Calm, supportive account-conversion step shown when the free introductory chat
// ends (or the guest requests a paid/persistent action). The guest can still READ
// the active conversation behind this modal; only new outgoing messages are paused.
export const AccountConversionModal = ({ isOpen, sessionId, guestToken, nearlyDone }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  const goAuth = (mode) => {
    // Stash what we need to link the guest session after authentication.
    if (guestToken) localStorage.setItem('pending_guest_token', guestToken);
    if (sessionId) localStorage.setItem('pending_guest_session', sessionId);
    navigate(`/auth?convert=1&mode=${mode}`);
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center bg-black/50 p-0 sm:p-4" data-testid="account-conversion-modal">
      <div className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl p-6 sm:p-8">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#FDF2F0] mb-4 mx-auto">
          <ShieldCheck className="text-[#7D202B]" size={24} />
        </div>
        <h2 className="text-xl sm:text-2xl font-heading font-semibold text-center text-[#3B2923] mb-2">
          Continue your support, securely
        </h2>
        <p className="text-center text-sm text-[#7A625C] leading-relaxed mb-6">
          Create or sign in to your Veyonika account to continue this conversation, access your
          shared resources, and receive ongoing care.
        </p>

        <button onClick={() => goAuth('register')} data-testid="conversion-create-account" className="btn-pill w-full mb-3 flex items-center justify-center gap-2">
          <UserPlus size={18} /> Create an account / Continue
        </button>
        <button onClick={() => goAuth('login')} data-testid="conversion-have-account" className="w-full py-3 rounded-full border border-[#E7D6D0] text-[#7D202B] font-medium hover:bg-[#FDF2F0] transition-colors flex items-center justify-center gap-2">
          <LogIn size={18} /> I already have an account
        </button>

        <p className="text-center text-xs text-[#A0AEC0] mt-4">
          {nearlyDone
            ? 'Your introductory chat is nearly complete.'
            : 'Your conversation is saved — you won\u2019t lose anything.'}
        </p>
      </div>
    </div>
  );
};

export default AccountConversionModal;
